import { render } from "./Marketing_Channels.vue?vue&type=template&id=54de9c19"
import script from "./Marketing_Channels.vue?vue&type=script&lang=js"
export * from "./Marketing_Channels.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__